module.exports = __webpack_public_path__ + "static/media/bg_default-active-challange.c1131fc9.jpg";